import React from 'react';
import { observer } from 'mobx-react-lite';
import NumberFormat from 'react-input-mask';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
// import d from 'dayjs';
import { useSeaCruiseStore } from '../../providers/RootStoreProvider';
// import { Modal } from '../Modal';
import { Button } from '../Button';
import { Input } from '../Input';
import { unFormatterPhone } from '../../utils/unFormatterPhone';
import { Anchor, Text } from '../Text';
import styles from './seaRequestMini.module.sass';
import { SuccessForm } from '../SuccessForm';
import { formatter } from '../../utils/formatter';

const fullSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Имя должно содержать больше 2 символов')
    .max(25, 'Имя не должно содержать больше 25 символов')
    .matches(/^[а-яА-ЯёЁa-zA-Z\s]+$/, 'Введите корректное Имя и Фамилию')
    .trim()
    .required('Обязательное поле'),
  phone: Yup.string()
    .trim()
    .min(11, 'Введите номер телефона')
    .max(11, '')
    .required('Обязательное поле'),
});

const phoneSchema = Yup.object().shape({
  phone: Yup.string()
    .trim()
    .min(11, 'Введите номер телефона')
    .max(11, '')
    .required('Обязательное поле'),
});

export const SeaRequestMini = observer(
  ({ isShips, users, minPrice, onlyPhone, isMobile }) => {
    const seaStore = useSeaCruiseStore();
    return (
      <div className={styles.main}>
        <div>
          <Formik
            validationSchema={onlyPhone ? phoneSchema : fullSchema}
            initialValues={{
              phone: '',
              name: users?.user?.name
                ? `${users?.user.name} ${users?.user.patronymic} ${users?.user.surname}`
                : 'Неавторизованный',
              success: false,
              cruis_id: seaStore.id,
              category_id: seaStore?.activeCabin?.category_info?.id,
              category_name: seaStore?.activeCabin?.category_info?.category,
            }}
            onSubmit={async (
              { phone, name, cruis_id, category_id, category_name },
              { setFieldValue },
            ) => {
              try {
                await seaStore.getRequestStatus(
                  name,
                  phone,
                  cruis_id,
                  category_id,
                  category_name,
                );
              } catch (e) {
                // eslint-disable-next-line no-console
                console.log('error', e);
              } finally {
                setFieldValue('success', true);
              }
              window.ym(35441960, 'reachGoal', 'price_request');
            }}
          >
            {({ values, setFieldValue, errors, touched, isSubmitting }) => (
              <>
                {!values.success ? (
                  <Form>
                    <div className={styles.block}>
                      <div className={styles.blockPrice}>
                        {minPrice ? (
                          <Text variant="price">
                            от {formatter(minPrice)} ₽ / чел.
                          </Text>
                        ) : (
                          <Text variant="price">Цена по запросу</Text>
                        )}
                      </div>
                      <div className={styles.blockMissing}>
                        {minPrice ? (
                          <Text variant="missing">Наличие кают по запросу</Text>
                        ) : (
                          <Text variant="missing">
                            Свободные каюты отсутствуют
                          </Text>
                        )}
                      </div>
                    </div>
                    <div className={styles.formik}>
                      <div className={styles.form}>
                        <div className={styles.formikPhone}>
                          <Input
                            noBoldLabel
                            control={NumberFormat}
                            values={values.phone}
                            label="Номер телефона"
                            id="phone"
                            name="phone"
                            mask="+7 999 999-99-99"
                            onChange={e => {
                              setFieldValue(
                                'phone',
                                unFormatterPhone(e.target.value),
                              );
                            }}
                            error={touched.phone && errors.phone}
                          />
                        </div>
                      </div>
                      <div className={styles.formikButton}>
                        <Button
                          size="lg"
                          fullWidth
                          background="primary"
                          type="submit"
                          disabled={isSubmitting}
                          onClick={() =>
                            window.ym(35441960, 'reachGoal', 'price_request')
                          }
                        >
                          {isShips ? 'Выбрать круиз' : 'Оставить заявку'}
                        </Button>
                      </div>
                    </div>
                    <div className={styles.mainPage}>
                      <div>
                        <Text variant="linkTextPopap">
                          или посмотрите все круизы
                        </Text>
                      </div>
                      <div>
                        <Anchor className={styles.mainPageLink} href="/sea">
                          на главной странице
                        </Anchor>
                      </div>
                    </div>
                  </Form>
                ) : (
                  <div className={styles.success}>
                    <SuccessForm
                      title={<span>Ваша заявка успешно отправлена!</span>}
                      text="Мы свяжемся с вами, если появятся свободные места или предложения схожих круизов."
                    />
                  </div>
                )}
              </>
            )}
          </Formik>
        </div>
      </div>
    );
  },
);
